<template>
  <div class="sinenav-list">
    <SidenavItem
      @active="active"
      @toggle="toggle"
      v-for="item in list"
      :key="item.name"
      :item="item"
    />
  </div>
</template>
<script>
import SidenavItem from './SidenavItem';

export default {
  components: {
    SidenavItem
  },
  props: {
    items: Array
  },
  data: () => ({
    list: []
  }),
  watch: {
    items(items) {
      const { name } = this.$route;
      this.updateTree(items, name);
    }
  },
  created() {
    const { name } = this.$route;
    this.updateTree(this.items, name);
  },
  methods: {
    updateTree(items, name) {
      const { children } = this.createTree(items, name);
      this.list = children;
    },
    createTree(items, name) {
      let _expanded = false;
      const _children = items.map(item => {
        if (item.children) {
          const { children, expanded } = this.createTree(item.children, name);
          return { ...item, children, expanded, active: expanded };
        }
        _expanded = _expanded || item.name === name;
        return { ...item };
      });
      return { children: _children, expanded: _expanded };
    },
    toggle(item) {
      item.expanded = !item.expanded;
    },
    active(name) {
      this.updateTree(this.items, name);
    }
  }
};
</script>

<style scoped>
.sinenav-list {
  width: 260px;
}
</style>
